import React from 'react'
import { SvgProps } from '../../SvgComponent/types'

const KeyIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame">
        <path
          id="Vector"
          d="M15.662 2.25464C17.5571 4.1497 17.5571 7.20728 15.662 9.10235C14.2606 10.5037 12.2063 10.87 10.4705 10.1852L8.44806 12.2077L8.99746 13.9833L7.06259 15.9182L5.28696 15.3688L3.98908 16.6667H1.25V13.9276L7.73143 7.44616C7.04666 5.71034 7.41294 3.65603 8.81433 2.25464C10.7094 0.359578 13.767 0.359578 15.662 2.25464Z"
          stroke={color || '#EDEBF7'}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default KeyIcon
